<template>
  <div class="home">
    <div class="modalVideoUrl" v-if="modalVideoUrl" @click="modalVideoUrl = null">
      <div class="video">
        <button type="button" @click="modalVideoUrl = null">
          <img src="@/assets/images/btn-close.png" />
        </button>

        <video
          autoplay
          loop=""
          playsinline=""
          muted=""
          controls
          v-if="modalVideoUrl.indexOf('https') == -1"
        >
          <source :src="require(`@/assets/videos/${modalVideoUrl}`)" />
        </video>

        <iframe v-else :src="modalVideoUrl + '&autoplay=1'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </div>
    </div>

    <div class="row">
      <Slider class="col-12 banner">
        <div class="item">
          <div class="banner-content">
            <div class="banner-text">
              <h1>Na Unipar, nossos
                colaboradores são
                os principais
                protagonistas!
              </h1>
              
              <router-link to="/vagas/358494-trabalhe-conosco-brasil/inscricao" class="btn btn-lg btn-outline-color-1 rounded-pill">
                CADASTRAR CURRÍCULO
              </router-link>
            </div>

            <img src="@/assets/images/banner-1.1.png" />
          </div>
        </div>
        <div class="item">
          <div class="banner-content">
            <div class="banner-text">
              <h1>
                Juntos fazemos a
                química acontecer
                com responsabilidade
                e sustentabilidade
              </h1>

              <router-link to="/vagas/358494-trabalhe-conosco-brasil/inscricao" class="btn btn-lg btn-outline-color-1 rounded-pill">
                CADASTRAR CURRÍCULO
              </router-link>
            </div>

            <img src="@/assets/images/banner-2.jpeg" />
          </div>
        </div>
        <div class="item">
          <div class="banner-content">
            <div class="banner-text">
              <h1>
                Comprometimento,
                dedicação, união.
                Venha fazer parte
                do #TimeUnipar
              </h1>

              <router-link to="/vagas/358494-trabalhe-conosco-brasil/inscricao" class="btn btn-lg btn-outline-color-1 rounded-pill">
                CADASTRAR CURRÍCULO
              </router-link>
            </div>

            <img src="@/assets/images/banner-3.png" />
          </div>
        </div>
      </Slider>
    </div>

    <div class="row pt-5 mt-5" id="faca-parte">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-center mb-2">Faça parte do nosso time!</span>
        <h1 class="text-color-2 text-center pb-5">A Unipar faz a química acontecer!</h1>

        <div class="video-thumb" @click="modalVideoUrl = 'https://www.youtube.com/embed/lOvFiT4gloU?si=D4dn4A1rqlx9PyKh'">
          <img src="@/assets/images/thumb-video-1.png" />
          <img src="@/assets/images/play.png" class="play">
        </div>

        <hr class="mb-0 mt-5" />
      </div>
    </div>


    <div class="row pt-5 mt-5 pb-5" id="a-unipar">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-center mb-2">#SomosUnipar</span>
        <h1 class="text-color-2 text-center pb-3">A UNIPAR</h1>
        <p class="text-center">Somos uma empresa que faz a química acontecer, e temos nosso nome na história da química. A Unipar é a indústria das indústrias, produz insumos fundamentais para vários segmentos econômicos. Nós estamos presentes em vários produtos fundamentais para a vida das pessoas e, além disso, contribuímos para um mundo melhor melhorando a vida das pessoas.</p>
      </div>
    </div>

    <div class="row mt-5" id="trabalhe-conosco">
      <div class="col-12 col-md-10 mx-auto">
        <div class="row align-items-center">
          <div class="col-12 col-md-5">
            <img src="@/assets/images/img-trabalhe-conosco.jpeg" style="height: 100%; object-fit: cover;" />
          </div>
          <div class="col-12 col-md-7 p-5">
            <span class="text-color-1 mb-3 text-center text-md-left">TRABALHE CONOSCO</span>
            <h2 class="text-color-2 mb-3 text-center text-md-left">Somos apaixonados pela química. Junte-se a nós e venha fazer a química acontecer!</h2>
            <p class="text-color-2 mb-4 text-center text-md-left">Na Unipar, estamos empenhados em liderar o caminho em soluções químicas inovadoras e sustentáveis. Acreditamos que nossa força reside nas pessoas que compõem a nossa equipe. Se você compartilha nossa paixão pela química, pela inovação e pelo desejo de fazer a diferença, convidamos você a se tornar parte do #SomosUnipar.</p>
            
            <div class="d-flex justify-content-center justify-content-md-start">
              <router-link to="/vagas/358494-trabalhe-conosco-brasil/inscricao" class="btn btn-color-1 rounded-pill py-2 px-5">
                CADASTRAR CURRÍCULO
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

     <div class="row pt-5 mt-5" id="gptw">
      <div class="col-12 col-md-10 mx-auto">
        <div class="d-flex align-items-center flex-column flex-md-row pb-5">
          <img src="@/assets/images/selo-gptw.png" style="max-height: 250px" id="selo-gptw" />
          <div class="p-5" id="texto-gptw">
            <span class="text-color-2 text-center mb-2">SOMOS GPTW</span>
            <h1 class="text-color-2 text-center pb-3">SOMOS GPTW EM 2023!</h1>
            <p class="text-color-2 text-center">É motivo de muita alegria receber novamente a certificação Great Place To Work® Brasil, que nos reconhece como uma das Melhores Empresas para Trabalhar no Brasil em 2023!</p>
            <p class="text-color-2 text-center">Agradecemos a todos os colaboradores que compartilham dos nossos valores e contribuíram para obtivéssemos este resultado. Esse reconhecimento reflete a consolidação de uma cultura organizacional cada vez mais sólida.Parabéns, equipe Unipar! Juntos, continuaremos fazendo a química acontecer!</p>
          </div>
        </div>

        <div class="video-thumb" @click="modalVideoUrl = 'gptw.mp4'">
          <img src="@/assets/images/thumb-video-2.png" />
          <img src="@/assets/images/play.png" class="play">
        </div>
      </div>
    </div>


    <div class="row pt-5 " id="historia">
      <div class="col-12 col-md-10 mx-auto">
        <div class="box d-flex align-items-center flex-column flex-md-row mb-5">
          <div class="p-5">
            <span class="text-color-2 text-left mb-2">EXPERIÊNCIA NO MERCADO</span>
            <h1 class="text-color-1 text-left pb-3">55 ANOS DE HISTÓRIA!</h1>
            <p class="text-color-2 text-left">Celebramos, em 2024, 55 anos de histórias, conquistas, desafios e marcos importantes. Ao longo desses anos, nos consolidamos como a indústria das indústrias, líderes na produção de Cloro e Soda na América do Sul, e a segunda maior na produção de PVC.</p>
            <p class="text-color-2 text-left">Sobre uma base sólida de sustentabilidade, competitividade e excelência operacional, nossa equipe trabalha diariamente para aprender, evoluir e melhorar constantemente e em conjunto.</p>
          </div>

          <img src="@/assets/images/historia.jpeg" style="height: 100%; object-fit: cover;" />
        </div>

         <div class="video-thumb" @click="modalVideoUrl = 'https://www.youtube.com/embed/ADeiHf9HuN0?si=Pmxl0Qrk44YRGeMM'">
            <img src="@/assets/images/thumb-video-3.png" />
            <img src="@/assets/images/play.png" class="play">
         </div>
      </div>
    </div>

    <div class="row pt-5 pb-5" id="fotos">
      <Slider mode="gallery" class="col-12 col-md-11 mx-auto banner">
        <div class="item">
          <img src="@/assets/images/gallery-1.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/gallery-2.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/gallery-3.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/gallery-4.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/gallery-5.png" />
        </div>
      </Slider>
    </div>

    <div class="row mt-5">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-left mb-2 text-center text-md-left">CONHEÇA NOSSOS PROGRAMAS</span>
        <h1 class="text-color-2 text-left pb-3 text-center text-md-left">Programas de desenvolvimento</h1>
        <p class="text-color-2 text-left mb-5 text-center text-md-left">Os programas de desenvolvimento são essenciais para a adaptação e o crescimento contínuo de uma empresa em um ambiente de negócios em constante evolução.</p>

        <div class="row justify-content-center">
          <div class="col-12 col-md-4 mb-5">
            <div class="box-programas">
              <h3>Jovem Aprendiz</h3>
              <p>Iniciativa voltada para jovens em idade de aprendizado que proporciona a oportunidade de combinar educação formal com experiência prática no mercado de trabalho.</p>
            </div>

            <!-- <a
              href="https://unipar.com/programa-aprendizagem-industrial/"
              class="btn btn-color-1 btn-block px-5 py-2 rounded-pill"
              target="_blank"
            >
              CLIQUE E SAIBA MAIS
            </a> -->
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-programas">
              <h3>Estágio Técnico</h3>
              <p>Iniciativa que oferece aos estudantes a oportunidade de adquirir experiência prática em seu campo de estudo, ao mesmo tempo que completam sua formação técnica.</p>
            </div>

            <!-- <a
              href="https://unipar.com/programa-de-estagio-unipar/"
              class="btn btn-color-1 btn-block px-5 py-2 rounded-pill"
              target="_blank"
            >
              CLIQUE E SAIBA MAIS
            </a> -->
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-programas">
              <h3>Estágio Universitário</h3>
              <p>Oportunidade para estudantes universitários ganharem experiência prática no campo de estudo deles enquanto ainda estão na faculdade.</p>
            </div>

            <!-- <a
              href="https://unipar.com/programa-de-estagio-unipar/"
              class="btn btn-color-1 btn-block px-5 py-2 rounded-pill"
              target="_blank"
            >
              CLIQUE E SAIBA MAIS
            </a> -->
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-programas">
              <h3>Programa de Desenvolvimento de Liderança Unipar</h3>
              <p>Na Unipar nossas pessoas são nossa prioridade número 1. Desenvolvemos esse programa com objetivo nos preparar para o crescimento do negócio, reforçar nossa Cultura UNIPAR e oferecer ferramentas de gestão de pessoas.</p>
            </div>

            <!-- <a
              href="https://unipar.com/pessoas/"
              class="btn btn-color-1 btn-block px-5 py-2 rounded-pill"
              target="_blank"
            >
              CLIQUE E SAIBA MAIS
            </a> -->
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-programas">
              <h3>Academia <img src="@/assets/images/logo-unipar-2.png" :alt="'Logotipo ' + $store.state.websiteName" :title="$store.state.websiteName" /></h3>
              <p>Nossa principal ferramenta de treinamento e desenvolvimento, com conteúdos customizados para nossos colaboradores.</p>
            </div>

            <!-- <a
              href="https://unipar.com/programa-academia-unipar/"
              class="btn btn-color-1 btn-block px-5 py-2 rounded-pill"
              target="_blank"
            >
              CLIQUE E SAIBA MAIS
            </a> -->
          </div>

          <div class="col-12 col-md-7 mx-auto">
            <a
              href="https://unipar.com/carreiras"
              class="btn btn-color-1 btn-block px-5 py-2 rounded-pill"
              target="_blank"
            >
            CLIQUE AQUI E SAIBA MAIS SOBRE OS PROGRAMAS DE DESENVOLVIMENTO
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5 py-5" style="background-color: #F2F2F2;">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-left mb-2 text-center text-md-left">TRABALHE CONOSCO</span>
        <h1 class="text-color-2 text-left pb-3 text-center text-md-left">Nossas certificações</h1>
        <p class="text-color-2 text-left text-center text-md-left">Nossas certificações asseguram a padronização e a gestão eficaz dos processos para atender os nossos públicos de interesse, preservar o meio ambiente e garantir a saúde e a segurança das pessoas.</p>

        <div class="row justify-content-center pt-5">
          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>ISO 9001</h3>
              <hr />
              <p>Busca gerenciar com eficácia os diferentes processos integrados na empresa, com o objetivo de aumentar a satisfação do cliente por meio da melhoria contínua e garantia de conformidade com seus requisitos.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>ISO 14001</h3>
              <hr />
              <p>Tem o objetivo de garantir a conformidade com as leis ambientais aplicáveis e identificar, controlar e minimizar os aspectos e impactos das atividades, produtos e serviços da empresa relacionados ao meio ambiente.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>ISO 45001</h3>
              <hr />
              <p>Busca garantir a conformidade com as legislações aplicáveis de segurança e saúde ocupacional e identificar, controlar e minimizar os pergios e riscos das atividades, produtos e serviços da empresa para preservar as pessoas.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>Atuação Responsável</h3>
              <hr />
              <p>É um compromisso com a melhoria contínua do desempenho em sáude, segurança e meio ambiente, promovendo a sustentavilidade e, contribuindo assim, para aumentar a qualidade de vida da sociedade.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>HALAL</h3>
              <hr />
              <p>É uma certificação de cunho religioso que segue requisitos para garantir alimentos lícitos aos seguidores do islamismo. Produtos ou alimentos halal são aqueles que obedecem a lei islâmica.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>KOSHER</h3>
              <hr />
              <p>É uma certificação de cunho religioso que segue requisitos para garantir alimentos lícitos aos seguidores do judaísmo. Produtos ou alimentos kosher são aqueles que obedecem a lei judaica.</p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row my-5 py-5">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-center mb-2">Nossas vagas estão abertas!</span>
        <h1 class="text-color-2 text-center pb-3">O cuidado com as pessoas é uma das premissas centrais na condução dos nossos negócios</h1>
        <p class="text-color-2 text-center mb-5">Nossas ações nos conectam com nossos objetivos de sustentabilidade. Por isso, contamos com cada colaborador para entregar resultados e gerar valor para clientes, acionistas, investidores, parceiros e para o planeta.</p>

        <div class="d-flex justify-content-center">
          <!-- <button class="btn btn-color-1 rounded-pill mx-2 px-5 py-3">CANDIDATE-SE</button> -->
          <router-link to="/vagas/358494-trabalhe-conosco-brasil/inscricao" class="btn btn-color-1 rounded-pill mx-2 px-5 py-3">
            CADASTRAR CURRÍCULO
          </router-link>
        </div>
      </div>
    </div>

    <hr />

    <div class="row my-5 py-5">
      <div class="col-12 col-md-10 mx-auto" id="vagas">
        <span class="text-color-2 text-center mb-2">Venha trabalhar com a gente!</span>
        <h1 class="text-color-1 text-center pb-3">VAGAS DISPONÍVEIS</h1>

        <Jobs :key="$route.fullPath" />
      </div>
    </div>

    <div class="row mt-5 py-5" style="background-color: #F2F2F2;">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-2 text-center mb-2">Depoimentos dos nossos colaboradores!</span>
        <h1 class="text-color-2 text-center pb-5">Como é ser do #TimeUnipar</h1>
      </div>

      <Slider class="col-12 banner">
        <div class="item">
          <div class="depoimento-item d-flex flex-column flex-md-row align-items-center">
            <div class="img">
              <img src="@/assets/images/depoimento-1.png" />
              <p class="text-left text-color-1 d-block d-md-none"><strong>Gabrielle Oliveira Gomes</strong> <br />Estagiário Universitário</p>
            </div>
            <div>
              <p class="text-left text-color-3">Fazer parte do time de estagiários da Unipar é gratificante, saber que estou em uma empresa que posso atrelar meus aprendizados e conhecimentos nos processos, e ver a química acontecer na prática é incrível.</p>
              <p class="text-left text-color-3">Ser estagiário Unipar, é você enfrentar os desafios do dia a dia de uma fábrica petroquímica, e sabendo que posso contar com o auxílio dos colegas de equipe e colegas estagiados de outras áreas, ter esse suporte nos motiva todos os dias.</p>
              <p class="text-left text-color-3">Ser estagiário Unipar, é você ter vivencias além da fábrica e do seu dia a dia de trabalho, é você ter a oportunidade de aprender cada dia mais. Ser estagiário Unipar, é você mostrar seu protagonismo e superar seus desafios todos os dias.</p>

              <p class="text-left text-color-1 d-none d-md-block"><strong>Gabrielle Oliveira Gomes</strong> <br />Estagiário Universitário</p>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="depoimento-item d-flex flex-column flex-md-row align-items-center">
            <div class="img">
              <img src="@/assets/images/depoimento-2.png" />
              <p class="text-left text-color-1 d-block d-md-none"><strong>Murilo Arizza</strong><br />Analista Tecnologia PI</p>
            </div>
            <div>
              <p class="text-left text-color-3">Na Unipar somos desafiados a crescer e a inovar todos os dias. A cultura de excelência e a busca constante pela melhoria nos impulsionam a alcançar novos patamares.</p>
              <p class="text-left text-color-3">É motivador fazer parte de um ambiente onde nossas ideias são valorizadas e nossa criatividade é incentivada.</p>
              <p class="text-left text-color-3">O compromisso da Unipar com a responsabilidade social e ambiental também é algo que me motiva a fazer parte desse time. Saber que estamos contribuindo para um mundo melhor faz toda a diferença.</p>

              <p class="text-left text-color-1 d-none d-md-block"><strong>Murilo Arizza</strong> <br />Analista Tecnologia PI</p>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="depoimento-item d-flex flex-column flex-md-row align-items-center">
            <div class="img">
              <img src="@/assets/images/depoimento-3.png" />
              <p class="text-left text-color-1 d-block d-md-none"><strong>Marcos Rogério Oliveira Franço</strong><br />Supervisor de Produção</p>
            </div>
            <div>
              <p class="text-left text-color-3">Nos últimos anos a Unipar vem se destacando não só como uma indústria de Base, mas também como uma empresa que se preocupa com outros assuntos, mostrando isso através de Sustentabilidade e Engajamento.</p>
              <p class="text-left text-color-3">Um exemplo que compartilho é sobre economia/fornecimento de energia e redução de poluentes. Com a implantação de uma nova Sala de Células Membrana (aposentando as Salas Diafragma e Mercúrio, aqui em Cubatão) e do Parque Eólico em Tucano. Fico contente em fazer parte do time da Unipar e presenciar/participar dessa evolução.</p>

              <p class="text-left text-color-1 d-none d-md-block"><strong>Marcos Rogério Oliveira Franço</strong> <br />Supervisor de Produção</p>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="depoimento-item d-flex flex-column flex-md-row align-items-center">
            <div class="img">
              <img src="@/assets/images/depoimento-4.png" />
              <p class="text-left text-color-1 d-block d-md-none"><strong>Amanda Edite do Nascimento Monteiro</strong><br />Analista Contas a Pagar Jr</p>
            </div>
            <div>
              <p class="text-left text-color-3">Ser do time Unipar te transforma positivamente, a oportunidade de desenvolver, observar de perto a relevância do ramo no nosso dia a dia e a importância que existe no tema meio ambiente.</p>
              <p class="text-left text-color-3">E que em meio a essa evolução e crescimentos, estamos caminhando juntos sendo parte e responsáveis por bons resultados e desta união fazendo a empresa evoluir.</p>
              <p class="text-left text-color-3">O acolhimento, o tema pessoas, abertura e se sentir necessário esta justificado em nossos resultados e internamente no fortalecimento da nossa cultura, nos sentimos parte dessa história.”</p>

              <p class="text-left text-color-1 d-none d-md-block"><strong>Amanda Edite do Nascimento Monteiro</strong> <br />Analista Contas a Pagar Jr</p>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="depoimento-item d-flex flex-column flex-md-row align-items-center">
            <div class="img">
              <img src="@/assets/images/depoimento-5.png" />
              <p class="text-left text-color-1 d-block d-md-none"><strong>Valéria Regina Paula dos Passos</strong><br />Assistente de Saúde Operacional</p>
            </div>
            <div>
              <p class="text-left text-color-3">Fazer parte de uma empresa séria e bem-conceituada como a UNIPAR faz eu me sentir vencedora. Ser reconhecida é o sonho de muitos profissionais e comigo não seria diferente.</p>
              <p class="text-left text-color-3">Pretendo contribuir ainda mais com o sucesso desta companhia, desenvolvendo meu trabalho sempre com muita responsabilidade, disposição e profissionalismo.</p>

              <p class="text-left text-color-1 d-none d-md-block"><strong>Valéria Regina Paula dos Passos</strong> <br />Assistente de Saúde Operacional</p>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="depoimento-item d-flex flex-column flex-md-row align-items-center">
            <div class="img">
              <img src="@/assets/images/depoimento-6.png" />
              <p class="text-left text-color-1 d-block d-md-none"><strong>Theid Gomes Dias</strong><br />Técnico de Construção & Montagem</p>
            </div>
            <div>
              <p class="text-left text-color-3">Uma grande empresa se constrói com grandes profissionais, e sinto muito orgulho em fazer parte do time Unipar, empresa em constante crescimento, que me inspira a buscar meu próprio desenvolvimento a cada ano!</p>

              <p class="text-left text-color-1 d-none d-md-block"><strong>Theid Gomes Dias</strong> <br />Técnico de Construção & Montagem</p>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="depoimento-item d-flex flex-column flex-md-row align-items-center">
            <div class="img">
              <img src="@/assets/images/depoimento-7.png" />
              <p class="text-left text-color-1 d-block d-md-none"><strong>Eric Guerra Michelini</strong><br />Estagiário Universitário</p>
            </div>
            <div>
              <p class="text-left text-color-3">Vivenciar o estágio na Unipar foi algo incrível. A equipe de toda a fábrica, colegas de trabalho e outros estagiários foram muito acolhedores e prestativos, sempre dispostos a me ensinar e me ajudar a crescer profissionalmente.</p>

              <p class="text-left text-color-3">Além disso, tive a oportunidade de aplicar os conhecimentos adquiridos no curso em projetos reais. Foi uma experiência enriquecedora que contribuiu para meu desenvolvimento pessoal e profissional.</p>

              <p class="text-left text-color-1 d-none d-md-block"><strong>Eric Guerra Michelini</strong> <br />Estagiário Universitário</p>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="depoimento-item d-flex flex-column flex-md-row align-items-center">
            <div class="img">
              <img src="@/assets/images/depoimento-8.png" />
              <p class="text-left text-color-1 d-block d-md-none"><strong>Francisco Matthews da Silva e Silva</strong><br />Engenheiro de Processos PI</p>
            </div>
            <div>
              <p class="text-left text-color-3">Fazer parte do time da Unipar é ter a certeza de ter grandes desafios e de um time disposto a resolvê-los. Mas além do dia a dia desafiante, o sentimento de pertencimento e propósito, alinhado ao engajamento da equipe, permite a leveza necessária para realizarmos o nosso trabalho com excelência.</p>

              <p class="text-left text-color-1 d-none d-md-block"><strong>Francisco Matthews da Silva e Silva</strong> <br />Engenheiro de Processos PI</p>
            </div>
          </div>
        </div>

      </Slider>
    </div>


    <div class="row py-5 enderecos">
      <div class="col-12 col-md-8 mx-auto">
        <h1 class="text-color-2 text-center">ENDEREÇOS UNIPAR BRASIL</h1>

        <hr class="my-5" />

        <div class="row">
          <div class="col-12 col-md-4">
            <h3>SÃO PAULO - SEDE</h3>

            <p>Avenida Presidente Juscelino
                Kubitschek, 1327 - 22º andar<br /><br />
                São Paulo - SP - Brasil<br /><br />
                CEP 04543-011<br /><br />
                Tel. <a href="tel:+551137044200">+55 (11) 3704-4200</a></p>
          </div>

          <div class="col-12 col-md-4">
            <h3>FÁBRICA CUBATÃO</h3>

            <p>Rod. Cônego Domênico
                Rangoni (SP-055), KM 267,7<br /><br />
                Pista Leste s/nº<br /><br />
                Cubatão - SP - Brasil<br /><br />
                CEP 11573 901<br /><br />
                Tel. <a href="tel:+551333628000">+55 (13) 3362-8000</a></p>
          </div>

          <div class="col-12 col-md-4">
            <h3>FÁBRICA SANTO ANDRÉ</h3>

            <p>Estrada de Ferro Santos Jundiaí KM 38<br /><br />
                Santo André - SP - Brasil<br /><br />
                CEP 09154-900<br /><br />
                Tel. <a href="tel:+5511344398822">+55 (11) 34439-8822</a></p>
          </div>
        </div>
      </div>
    </div>

    <div class="row py-5 enderecos" style="background-color: #F2F2F2;">
      <div class="col-12 col-md-8 mx-auto">
        <h1 class="text-color-2 text-center">ENDEREÇOS UNIPAR ARGENTINA</h1>

        <hr class="my-5" />

        <div class="row justify-content-center">
          <div class="col-12 col-md-4">
            <h3>BUENOS AIRES</h3>

            <p>Av. Juana Manso 555 7º D<br /><br />
                Puerto Madero - CABA<br /><br />
                C1107CBK<br /><br />
                Tel. <a href="tel:+541152839300">+54 (11) 5283-9300</a></p>
          </div>

          <div class="col-12 col-md-4">
            <h3>FÁBRICA BAHÍA BLANCA</h3>

            <p>Av. Pte. Frondizi 2450<br /><br />
                Puerto Galván - Bahia Blanca<br /><br />
                B8101XAD<br /><br />
                Tel. <a href="tel:+540291459300">+54 (0291) 459-300</a></p>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import Slider from "@/components/Slider.vue";
import Faq from "@/components/Faq.vue";
import Share from "@/components/jobs/Share.vue";
import Jobs from "@/components/jobs/Jobs.vue";

export default {
  name: "home",

  data() {
    return {
      modalVideoUrl: null
    };
  },

  components: {
    Slider,
    Faq,
    Share,
    Jobs,
  },

  mounted() {
    if(this.$route.hash == '#vaga'){
      setTimeout(() => {
        this.$router.push({ hash: '#vagas' });
      }, 200)
    }
  },

  methods: {
  },
};
</script>

<style lang="scss" scoped>
  /deep/.banner{
     .banner-content{
        background: #F2F2F2;
        display: flex;
        width: 100%;

        @media (max-width: 980px){
          flex-direction: column;
        }

        img{
          width: 50%;
          max-height: 500px;
          object-fit: cover;

          @media (max-width: 980px){
            width: 100%;
          }
        }
     }

    .banner-text{
      flex-shrink: 0;
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding: 0 150px;

      @media (max-width: 980px){
        width: 100%;
        padding: 80px;
        align-items: center;
      }

      h1{
        margin-bottom: 30px;
        text-align: left;
        font-size: 42px !important;
        line-height: 1.2 !important;

        @media (max-width: 980px){
          text-align: center;
        }
      }
    }

    .tns-controls{
      position: absolute;
      left: 5%;
      right: 5%;
      /* height: 100%; */
      top: 50%;
      margin-top: -24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 1;

      @media (max-width: 600px){
        /* height: auto; */
        /* top: 100%; */
      }

      button{
        width: 48px;
        height: 48px;
        border: none;
        background: none;
        padding: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;

        &[data-controls="prev"]{
          background-image: url('../assets/images/arrow-left.svg');
        }
        &[data-controls="next"]{
          background-image: url('../assets/images/arrow-right.svg');
        }
        &[disabled]{
          opacity: 0.2;
        }

        @media (max-width: 600px){
          width: 38px;
          height: 38px;
        }
      }
    }

    .tns-item.item{
      display: inline-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      h1{
        max-width: 820px;
        font-family: 'Inter', sans-serif;
        font-size: 36px;
        font-weight: 700;
        line-height: 42px;
        letter-spacing: -0.02em;
        /* text-align: center; */
        color: #000000;
        @media (max-width: 980px){
          max-width: 400px;
        }
        @media (max-width: 600px){
          max-width: 90vw;
          font-size: 28px;
        }
        img{
          display: inline-block;
          vertical-align: baseline;
        }
      }

      p{
        max-width: 820px;
        font-family: 'Inter', sans-serif;
        font-size: 24px;
        font-weight: 400;
        line-height: 46px;
        letter-spacing: 0em;
        text-align: center;

        @media (max-width: 980px){
          max-width: 400px;
        }
        @media (max-width: 600px){
          max-width: 90vw;
          font-size: 20px;
          line-height: 1.6;
        }
      }
    }
  }

  .video-thumb{
    width: 100%;
    height: 550px;
    background: #999;
    border-radius: 32px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &::before{
      content: '';
      display: block;
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.1);
      z-index: 2;
    }

    img:not(.play){
      position: absolute;
      inset: 0;
      z-index: 1;
      object-fit: cover;
      max-width: none;
      width: 100%;
      height: 100%;
      object-position: center;
    }

    img.play{
      width: 80px;
      height: 80px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -40px;
      margin-top: -40px;
      z-index: 1;
    }
  }

  hr{
    border-color: #E1E1E1;
  }

  span{
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    /* line-height: 24px; */
    letter-spacing: 0.03em;
    display: block;
  }

  h1{
    font-family: Inter;
    font-size: 42px;
    font-weight: 700;
    /* line-height: 83px; */
    letter-spacing: 0em;
  }

  h2{
    font-family: Inter;
    font-size: 42px;
    font-weight: 500;
    /* line-height: 62px; */
    letter-spacing: 0em;
  }

  p{
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    /* line-height: 24px; */
    letter-spacing: 0em;
  }

  .box{
    border-radius: 32px;
    background: #F2F2F2;
    overflow: hidden;

    img{
      max-width: 500px;
    }

    h1{
      font-size: 38px;
    }
  }

  .modalVideoUrl{
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;

    button{
      width: 45px;
      height: 45px;
      background-color: theme-color('color-1');
      position: absolute;
      left: 20px;
      top: 20px;
      border-radius: 50%;
      border: none;
    }

    .video{
      width: 90%;
      height: 100%;
      max-width: 800px;
      max-height: 500px;
      position: relative;
      background-color: theme-color('color-1');
      border-radius: 32px;
    }

    iframe, video{
      border-radius: inherit;
      width: 100%;
      height: 100%;
    }
  }

  .box-programas{
    background-color: #F2F2F2;
    padding: 50px 30px;
    border-radius: 32px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: calc(100% - 60px);

    h3{
      font-family: Inter;
      font-size: 26px;
      font-weight: 600;
      line-height: 34px;
      letter-spacing: 0em;
      text-align: left;
      color: #22232B;
      img{
        height: 32px;
        vertical-align: middle;
      }
    }

    p{
      font-family: Inter;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      letter-spacing: 0em;
      text-align: left;
      color: #22232B;
    }
  }

  .box-certificacao{
    h3{
      font-family: Inter;
      font-size: 32px;
      font-weight: 600;
      line-height: 42px;
      letter-spacing: 0em;
      text-align: center;
      color: #0a3200;
    }

    hr{
      border-color: #0a3200;
      margin: 15px auto;
      max-width: 100px;
    }

    p{
      font-family: Inter;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: center;
      color: #22232B;
    }
  }

  .enderecos{
    h1{
      font-size: 30px;
    }

    hr{
      border-color: #0a3200;
      margin: 15px auto;
      max-width: 200px;
    }

    h3{
      font-family: Inter;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 0em;
      color: #22232B;
    }

    p{
      font-family: Inter;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0em;
      text-align: left;
      color: #858585;

      a{
        color: inherit;
      }
    }
  }


  #trabalhe-conosco{
    background-color: #F2F2F2;

    @media (max-width: 980px){
      background-color: #ffff;
    }
  }


  #gptw{
    #selo-gptw{
      @media (max-width: 980px){
        order: 2;
      }
    }
  }

  /deep/ .depoimento-item{
    max-width: 70%;

    .img{
      width: 200px;
      height: 200px;
      flex-shrink: 0;
      flex-grow: 1;
      margin-right: 20px;
      display: flex;
      align-items: center;

      @media (max-width: 720px){
        width: auto;
        height: auto;
        order: 2;
        margin-right: 0;
        margin-top: 20px;

        img{
          width: 120px;
          height: 120px;
          margin-right: 20px;
        }
      }
    }

    img{
      width: 200px;
      height: 200px;
      border-radius: 50%;
    }

    p{
      font-size: 14px !important;
      line-height: 1.4 !important;
      max-width: none !important;
    }
  }

</style>
